import ExampleItemList from '@/components/ExamplesContent/ExampleItemList';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

const ExampleReportContent = () => {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);

  const handleHideDemoProfiles = () => {
    setVisible(false);
    setDemoProfilesVisible(false);
  };

  useEffect(() => {
    const hideDemoProfiles = getDemoProfilesVisible();
    if (hideDemoProfiles) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  if (!visible) {
    return <></>;
  }

  return (
    <div>
      {/* 标题和隐藏按钮 */}
      <div className="pt-8 pb-8 text-[0.875rem] text-center text-[rgba(12,12,12,0.6)]">
        {t('Examples')}
        {', '}
        <span className="cursor-pointer hover:text-[#725CFF]" onClick={handleHideDemoProfiles}>
          {t('Hide Demo Profiles')}
        </span>
      </div>
      {/* 示例报告列表 */}
      <ExampleItemList />
    </div>
  );
};

export const DEMO_PROFILES_VISIBLE_KEY = 'demoProfilesVisible';

export const getDemoProfilesVisible = () => {
  const hideDemoProfiles = localStorage.getItem(DEMO_PROFILES_VISIBLE_KEY) === 'false';
  return hideDemoProfiles;
};

export const setDemoProfilesVisible = (visible: boolean) => {
  localStorage.setItem(DEMO_PROFILES_VISIBLE_KEY, visible ? 'true' : 'false');
};

export const clearDemoProfilesVisible = () => {
  localStorage.removeItem(DEMO_PROFILES_VISIBLE_KEY);
};

export default ExampleReportContent;
